/**
 * @generated SignedSource<<2fc062ad284a3354a3f764cc0641f626>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailRingSize_detailValues$data = ReadonlyArray<{
  readonly browseUrl?: string | null;
  readonly ringSizes?: ReadonlyArray<{
    readonly unit: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedDetailRingSize_detailValues";
}>;
export type PdpSharedDetailRingSize_detailValues$key = ReadonlyArray<{
  readonly " $data"?: PdpSharedDetailRingSize_detailValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailRingSize_detailValues">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedDetailRingSize_detailValues",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RingSizeDetail",
          "kind": "LinkedField",
          "name": "ringSizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PdpDetailRingSize",
      "abstractKey": null
    }
  ],
  "type": "PdpDetailValueInterface",
  "abstractKey": "__isPdpDetailValueInterface"
};

(node as any).hash = "e42a35bca1ca5390830f5ae2a80a7734";

export default node;
